import i18n from '@shared/i18n';

export enum INVOICE_TYPE {
    MOBILE_BARCODE = 'mobile_barcode',
    EXEMPT = 'exempt',
    PAPER = 'paper',
    BUSINESS = 'business',
    NATURAL_ID = 'natural_id',
    DONATE = 'donate',
    PRINTED_E_INVOICE = 'printed_e_invoice',
}

export enum CART_ADDRESS_FORM_FIELD_NAME {
    NAME = 'address_field_name',
    PHONE_CODE = 'address_field_phone_code',
    PHONE = 'address_field_phone',
    EMAIL = 'address_field_email',
    ZIP_CODE = 'address_field_zip_code',
    COUNTY = 'address_field_county',
    COUNTRY = 'address_field_country',
    DISTRICT = 'address_field_district',
    ROAD = 'address_field_road',
    STORE = 'address_field_store',
    ADDRESS = 'address_field_address',
}

export enum ROLE {
    BUYER = 'buyer',
    RECEIVER = 'receiver',
}

export enum TOAST_TYPE {
    PROMO_EXPIRED = 'promo_expired',
    ORDER_GIVEAWAY_INVALID = 'order_giveaway_invalid',
    STOCK_NOT_ENOUGH = 'stock_not_enough',
    MINIMUM_ORDER_AMOUNT = 'minimum_order_amount',
    SHIPPING_NOT_AVAILABLE = 'shipping_not_available',
}

export const INVOICE_TYPE_KEYS_MAP = {
    mobileBarcode: 'mobile_barcode',
    exempt: 'exempt',
    paper: 'paper',
    business: 'business',
    naturalId: 'natural_id',
    donate: 'donate',
    printedEInvoice: 'printed_e_invoice',
} as const;

export const DEFAULT_CHARITY_OPTIONS_MAP = [
    { value: '1357', label: i18n.gettext('社團法人中華民國紅心字會') },
    { value: '7665', label: i18n.gettext('財團法人流浪動物之家基金會') },
    { value: '1728', label: i18n.gettext('社團法人中華民國創世社會福利基金會') },
    { value: '5220', label: i18n.gettext('社團法人中華民國喜憨兒社會福利基金會') },
];
